import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ItemSelectionReusedWarningDialogData } from '../util/interfaces';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { LocalizationService } from 'src/app/general/services/localization.service';
import { MenuEditorUtil } from '../util/menu-editor-util';
import { DataTableComponent } from 'src/app/general/components/data-table/data-table.component';
import { DataTableColumn, StringColumn } from 'src/app/general/components/data-table/data-table-column';
import * as proto from 'src/proto/compiled-protos';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public showWarning(): void {
//   const inputDialogData: ItemSelectionReusedWarningDialogData = {
//     ...
//   }
//   this.itemSelectionReusedWarningDialogService.openDialog(inputDialogData);
// }

// ----------------------------------------------------------------------------

@Component({
  selector: 'app-item-selection-reused-warning-dialog',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    DataTableComponent
  ],
  templateUrl: './item-selection-reused-warning-dialog.component.html',
  styleUrls: ['./item-selection-reused-warning-dialog.component.css']
})
export class ItemSelectionReusedWarningDialogComponent {

  columns: Array<DataTableColumn<proto.waiternow.common.ITextProto>> = [
    new StringColumn(
        /* name= */ 'menuItem',
        /* translateId= */ 'menu_item',
        /* valueExtractor= */  textProto => this.getNonEmptyText(textProto)),
  ];

  constructor(
      public dialogRef: MatDialogRef<ItemSelectionReusedWarningDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: ItemSelectionReusedWarningDialogData,
      private localizationService: LocalizationService) {
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  public getNonEmptyText(textProto: proto.waiternow.common.ITextProto): string {
    return MenuEditorUtil.getNonEmptyText(textProto, this.localizationService);
  }
}
